export const gradeEnum = {
    'INSTITUIÇÃO': 'Intituição',
    'GRÃ-CRUZ': 'Grã-Cruz',
    'ALTA-DISTINÇÃO': 'Alta-Distinção',
    'DISTINÇÃO': 'Distinção',
    'BONS SERVIÇOS': 'Bons Serviços',
    'MINISTRO': 'Ministro'
};
